module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "talent-detail"
    }
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_vm._v("达人管理 >\n        "), _c('span', [_vm._v("查看达人账号")]), _vm._v(" "), _c('span', [_c('el-button', {
    staticClass: "right_f",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "talent-box"
  }, [_c('p', [_vm._v("基础信息")]), _vm._v(" "), _c('el-row', {
    staticClass: "talent-info"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.infoList), function(item) {
    return _c('div', {
      staticClass: "talent-box-item"
    }, [_c('span', {
      staticClass: "common-title"
    }, [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('span', {
      staticClass: "common-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.statisticsList), function(item) {
    return _c('div', {
      staticClass: "talent-box-item"
    }, [_c('span', {
      staticClass: "common-title"
    }, [_vm._v(_vm._s(item.key))]), _vm._v(" "), _c('span', {
      staticClass: "common-value"
    }, [_vm._v(_vm._s(item.value))])])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-box"
  }, [_c('p', [_vm._v("操作记录")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "data": _vm.operateList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": "操作类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operationTime",
      "label": "操作时间"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reason",
      "label": "取消原因"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator",
      "label": "操作人"
    }
  })], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e676dff6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/talent/talentDetail.vue
// module id = 1135
// module chunks = 0